declare var bootstrap: any;

import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '../../../../../material.module';
import {TablerIconsModule} from 'angular-tabler-icons';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LocalizationService} from '../../../../../services/localizationService';
import {PermissionService} from '../../../../../../core/authorization/permission.service';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {LocalizationPipe} from "../../../../../pipe/localization-pipe";
import {MatTableDataSource} from "@angular/material/table";
import {KeycloakService} from "../../../keyCloak/keycloak.service";
import {EnumOrganisationType, OrganisationDTO} from "../../../../../DTO/Organisation/OrganisationDTO";
import {KeycloakUserEntity} from "../../../keyCloak/models/keycloak-user-entity";
import {PageableRequest} from "../../../../../../core/PageableRequest";
import * as XLSX from 'xlsx';

@Component({
    selector: 'app-organisation-user-list',
    templateUrl: './organisation-user-list.component.html',
    styleUrls: ['./organisation-user-list.component.scss'],
    standalone: true,
    imports: [CommonModule, MaterialModule, TablerIconsModule, FormsModule, ReactiveFormsModule, LocalizationPipe]
})
export class OrganisationUserListComponent implements OnInit, AfterViewInit {
    @Input() selectedOrganisationId: number;
    selectedOrganisation: OrganisationDTO;
    pageableRequest = new PageableRequest();
    totalCount=0;
    pageNumber=0;
    displayedColumns: string[] = [
        'first_name',
        'last_name',
        'email',
        'email_verified',
        'enabled',
        'roles'
    ];


    constructor(
        private router: Router,
        public localizationService: LocalizationService,
        private keycloakService: KeycloakService,
        public permissionService: PermissionService,
        public dialog: MatDialog,
        private snackBar: MatSnackBar
    ) {
    }

    userMap: MatTableDataSource<any> = new MatTableDataSource<KeycloakUserEntity>();

    createUserList:KeycloakUserEntity[]=[];
    createUserListDemo:KeycloakUserEntity[]=[];
    saveRequestSended=false;

    ngOnInit(): void {
        if (this.selectedOrganisationId) {
            this.selectedOrganisation = new OrganisationDTO();
            this.selectedOrganisation.id = this.selectedOrganisationId;
        } else if (window.globalActiveUser && window.globalActiveUser.organisationAccount && window.globalActiveUser.organisationAccount.id) {
            this.selectedOrganisation = new OrganisationDTO();
            this.selectedOrganisation.id = window.globalActiveUser.organisationAccount.id;
        }
        this.pageableRequest.filters = new Map<string, string>();
        this.pageableRequest.size = 10;
        this.pageableRequest.page = 0;
        this.findOrganisationUser();
    }

    onPageChange(event: any): void {
        this.pageableRequest.filters.clear();
        this.pageableRequest.size = event.pageSize;
        this.pageableRequest.page = event.pageIndex;
        this.pageNumber=event.pageIndex;
        this.findOrganisationUser();
        // this.pageIndex = event.pageIndex;
        // this.pageSize = event.pageSize;
        // this.loadSystemUsers(this.pageIndex, this.pageSize);
    }

    findOrganisationUser(): void {
        this.pageableRequest.filters.set("organisationId", this.selectedOrganisation.id.toString());

        this.userMap = new MatTableDataSource<KeycloakUserEntity>();
        this.keycloakService.getUsersByOrganizationId(this.pageableRequest).subscribe({
            next: (response) => {
                if (response && response.data) {
                    this.totalCount=response.data.totalElements;
                    if (response.data.content && response.data.content.length > 0) {
                        this.userMap = new MatTableDataSource<KeycloakUserEntity>();
                        response.data.content.forEach((user: KeycloakUserEntity) => {
                            this.userMap.data.push(new KeycloakUserEntity(user));
                        });
                    }
                }
            }
        });
    }


    onUserAddFileChange(event: any): void {
        this.createUserListDemo=[];
        const target: DataTransfer = <DataTransfer>(event.target);
        if (target.files.length !== 1) {
            console.error('Lütfen sadece bir dosya yükleyin.');
            return;
        }
        this.createUserList=[];

        const file: File = target.files[0];
        const reader: FileReader = new FileReader();

        reader.onload = (e: any) => {
            const binaryData = e.target.result;
            const workbook: XLSX.WorkBook = XLSX.read(binaryData, { type: 'binary' });

            const sheetName: string = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            // Başlıksız olarak tüm veriyi 2 boyutlu array olarak al
            const rows: any[][] = XLSX.utils.sheet_to_json(sheet, { header: 1 });

            for (let i = 0; i < (rows.length>999?1000:rows.length); i++) {
                const row = rows[i];

                let _user= new KeycloakUserEntity();
                _user.first_name = row[0];
                _user.last_name = row[1];
                _user.email = row[2];

                this.createUserList.push(_user);
            }

        };

        reader.readAsBinaryString(file);

        const modalElement = document.getElementById('userCreateFileModal');
        const modal = new bootstrap.Modal(modalElement);
        modalElement?.addEventListener('shown.bs.modal', () => {
            document.querySelectorAll('.modal-backdrop').forEach(el => {
                const backdrop = el as HTMLElement;
                backdrop.style.zIndex = 'unset';
                backdrop.style.opacity = '0.5';
            });
        });
        modal.show();
    }

    openCreateUserFileDemo(){
        this.saveRequestSended=false;
        this.createUserListDemo=[];

        let _user= new KeycloakUserEntity();
        _user.first_name = "Kullanıcı-1";
        _user.last_name ="Soyad-1";
        _user.email = "kullanici1@example.com";
        this.createUserListDemo.push(_user);

        _user= new KeycloakUserEntity();
        _user.first_name = "Kullanıcı-2";
        _user.last_name ="Soyad-2";
        _user.email = "kullanici2@example.com";
        this.createUserListDemo.push(_user);


        _user= new KeycloakUserEntity();
        _user.first_name = "Kullanıcı-3";
        _user.last_name ="Soyad-3";
        _user.email = "kullanici3@example.com";
        this.createUserListDemo.push(_user);

        const modal = new bootstrap.Modal(document.getElementById('userCreateFileModal'));
        modal.show();
        document.querySelectorAll('.modal-backdrop').forEach(el => {
            (el as HTMLElement).style.zIndex = 'unset';
        });
    }

    deleteUserOnAddFile(index: number,demo:boolean): void {
        if(demo==false){
            this.createUserList.splice(index, 1);
        }
    }

    importSingleUser(index: number): void {
        let _user=this.createUserList[index];
        this.keycloakService.importUsers([_user]).subscribe({
            next: (response) => {
                this.createUserList[index].bindData(response["data"][0]);
            }
        });

    }


    saveImportUserList(){
        this.keycloakService.importUsers(this.createUserList).subscribe({
            next: (response) => {
                this.createUserList=[];
                response["data"].forEach(u=>{
                    let _user= new KeycloakUserEntity();
                    _user.bindData(u);
                    this.createUserList.push(_user);
                });
                this.saveRequestSended=true;
            }
        });
    }

    ngAfterViewInit(): void {

    }


    protected readonly window = window;
    protected readonly EnumOrganisationType = EnumOrganisationType;
}
